// extracted by mini-css-extract-plugin
export var bodyRow = "_gh-d";
export var cardColumns = "_gh-e";
export var ellipsesOverflow = "_gh-2";
export var flatBottomCorners = "_gh-3";
export var flatTopCorners = "_gh-4";
export var headerActionsDropdown = "_gh-f";
export var headerBottomRow = "_gh-c";
export var headerTopRow = "_gh-b";
export var orderDetailsWrapper = "_gh-0";
export var orderInfoContainer = "_gh-1";
export var productDetails = "_gh-9";
export var productImage = "_gh-5";
export var responsiveTable = "_gh-8";
export var shipmentContainer = "_gh-a";
export var tableBottomLeft = "_gh-6";
export var tableBottomRight = "_gh-7";